import { useNavigate } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import { routes } from 'statics';

import Button from '../‌Button';

const Fallback: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      w="100%"
      h="100dvh"
      textAlign="center"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDir="column"
    >
      <Text>Error occurred. Please try again later.</Text>
      <Button
        mt={4}
        onClick={() => navigate(routes.dashboard.url)}
        title="Back to Home"
      />
    </Box>
  );
};
export default Fallback;
